import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { isAuthSelector } from '../ducks/login';
import {
    dictionariesSelector,
    gridsSelector,
    homePageSelector,
    isCustomPageSelector,
    isPasswordExpiredSelector,
} from '../ducks/profile';
import {CHANGE_PASSWORD_LINK, customPage} from './links';

function PrivateRoute({ component: Component, ...rest }) {
    const isAuth = useSelector(state => isAuthSelector(state));
    const homePage = useSelector(state => homePageSelector(state));

    const gridsMenu = useSelector(state => gridsSelector(state)) || [];
    const dictionaryMenu = useSelector(state => dictionariesSelector(state)) || [];
    const isCustomPage = useSelector(state => isCustomPageSelector(state)) || {};
    const isPasswordExpired = useSelector(state => isPasswordExpiredSelector(state));

    const { computedMatch, location, permission = '' } = rest;
    const { path, params } = computedMatch;

    if (
        (params.name && path.includes('grid') && !gridsMenu.includes(params.name) && !params.isHidden) ||
        (params.name && path.includes('dictionary') && !dictionaryMenu.includes(params.name)) ||
        (customPage.includes(path) && !isCustomPage[permission])
    ) {
        return (
            <Redirect
                to={{
                    pathname: homePage,
                    state: { from: location },
                }}
            />
        );
    }

    return (
        <Route
            {...rest}
            render={props =>
                isAuth ? (
                    (isPasswordExpired && !path.includes(CHANGE_PASSWORD_LINK)) ? <Redirect
                        to={CHANGE_PASSWORD_LINK}
                    /> : <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateRoute;
